import { Injectable, inject } from '@angular/core'
import { ActivatedRouteSnapshot } from '@angular/router'
import { ElderToastService } from '@elderbyte/ngx-starter'
import { EMPTY, Observable } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { ControlTerminal } from './control-terminal'
import { ControlTerminalService } from './control-terminal.service'

@Injectable({
  providedIn: 'root',
})
export class ControlTerminalResolver {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private controlTerminalService = inject(ControlTerminalService)
  private toastService = inject(ElderToastService)

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  resolve(route: ActivatedRouteSnapshot): Observable<ControlTerminal> {
    const id = route.paramMap.get('terminalId')

    return this.controlTerminalService.findById(id).pipe(
      catchError((err) => {
        this.toastService.error('messages.loading_failed', err)
        return EMPTY
      })
    )
  }
}
